import { initCWElements, type CWEnv } from "@cw-elements/config";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import Smartlook from "smartlook-client";
import "syngenta-digital-cropwise-react-ui-kit/dist/styles/cw-ui-kit.less";
import App from "./App";
import AppProviders from "./context";
import "./i18n";
import "./index.less";
import "./mfe-bootstrap";
import reportWebVitals from "./reportWebVitals";
import { initializeAmplitude } from "./shared/utils/amplitude";
import { initializeDatadogRUM } from "./shared/utils/datadog";
import { getAccessToken } from "./lib/auth/accessToken";

const SMARTLOOK_API_KEY = process.env.REACT_APP_SMARTLOOK_API_KEY ?? null;

initializeAmplitude();
initializeDatadogRUM();
if (SMARTLOOK_API_KEY) {
  Smartlook.init(SMARTLOOK_API_KEY);
}

export { getAccessToken };

const initClients = (): any => {
  initCWElements({
    environment: process.env.REACT_APP_CROPWISE_PLATFORM_ENV as CWEnv,
    token: getAccessToken(),
    hostAppId: process.env.REACT_APP_TRIALING_APP_ID as string,
  });
};
try {
  initClients();
} catch (e) {
  console.error("Error", e);
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AppProviders>
        <App />
      </AppProviders>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
